import { ArrowUpRight } from "lucide-react";

export default function Footer() {
  return (
    <div className="w-full flex flex-col gap-6 items-start">
      <a
        href="https://vpsai.io/"
        target="_blank"
        rel="noreferrer noopener"
        className="w-full text-secondary flex items-center justify-between gap-2 hover:text-primary transition-colors duration-300"
      >
        Go to website
        <ArrowUpRight className="w-4 h-4" />
      </a>
    </div>
  );
}
